<template>
  <el-dialog v-bind="$attrs"
             v-on="$listeners"
             title="海尔生物医疗经销商引入评估"
             append-to-body
             :close-on-click-modal="false"
             width="90%">
    <div class="h-content paddingtopcls">
      <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;margin-top: 30px;">
        <h1>引入评估</h1>
      </div>
      <div>
        <table style ="border-collapse: collapse;width:80%; margin-bottom: 20px ;margin-top: 20px;margin-left: 60px;" cellspacing =0 border="1">
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" rowspan = "3"><img
                src="../../../public/assets/images/flow/agent_score.png" height="32" width="108"/></td>
            <td style="width: 180px" colspan = "2" rowspan = "3" class="title">海尔生物医疗经销商引入评估</td>
            <td style="width: 100px" >编号：GNSCB-02-F01</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">版本：B</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">页次：1/1</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" colspan = "4" class="subheading">基础信息</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">区    域 </td>
            <td style="width: 180px">{{bscUserInfoAgent.areaname}}</td>
            <td style="width: 100px">申请日期</td>
            <td style="width: 100px">{{bscUserInfoAgent.creationDate}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">公司名称</td>
            <td style="width: 180px">{{bscUserInfoAgent.username}}</td>
            <td style="width: 100px">法人代表</td>
            <td style="width: 100px">{{bscUserInfoAgent.legal}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">对接人</td>
            <td style="width: 180px">{{bscUserInfoAgent.name1}}</td>
            <td style="width: 100px">联系电话</td>
            <td style="width: 100px">{{bscUserInfoAgent.contactmobilephone}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">对阵地市（个数）</td>
            <td style="width: 180px">{{bscUserInfoAgent.againstAreaCount}}</td>
            <td style="width: 100px">对阵用户（个数）</td>
            <td style="width: 100px">{{bscUserInfoAgent.againstUserCount}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" colspan = "4" class="subheading">引入评估项目</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" class="subheading">评估项目</td>
            <td style="width: 180px" class="subheading">项目描述</td>
            <td style="width: 100px" class="subheading">见证资料（附件为必传项）</td>
            <td style="width: 100px" class="subheading">合格/不合格</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">人员配置</td>
            <td style="width: 180px">员工6名以上，一线销售人员3名以上</td>
            <td style="width: 100px">提供公司缴纳社保人员数量</td>
            <td style="width: 100px">
              <el-select v-model="bscUserInfoAgent.staffing" placeholder="请选择" class="select" @change="changeStaffing($event)" style="width:100px;border: none;box-shadow: none">
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
              </el-select>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">公司规模</td>
            <td style="width: 180px">上年度销售业绩：A类区域≥1200万，B类区域≥1000万，C类区域≥600万</td>
            <td style="width: 100px">提供上年度审计表</td>
            <td style="width: 100px">
              <el-select v-model="bscUserInfoAgent.scale" placeholder="请选择" @change="changeScale($event)" style="width:100px;">
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
              </el-select>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">经营资质</td>
            <td style="width: 180px">临床检验分析仪器、二类6858-3、6853-4、11-01、22-14、22-15、22-16三类6854-1、22-16</td>
            <td style="width: 100px">提供营业执照、经营许可证</td>
            <td style="width: 100px">
              <el-select v-model="bscUserInfoAgent.qualification" @change="changeQualification($event)" placeholder="请选择" style="width:100px">
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
              </el-select>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">品牌能力</td>
            <td style="width: 180px">同行业相关产品的代理授权书或证书</td>
            <td style="width: 100px">提供同行业品牌授权文件</td>
            <td style="width: 100px">
              <el-select v-model="bscUserInfoAgent.brandPower" placeholder="请选择" @change="changebrandPower($event)" style="width:100px">
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
              </el-select>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">业务能力</td>
            <td style="width: 180px">近两年中标业绩证明或合同证明10份以上，或用户合同规模≥600万</td>
            <td style="width: 100px">提供合同或业绩证明文件</td>
            <td style="width: 100px">
              <el-select v-model="bscUserInfoAgent.businessPower" @change="changehBusinessPower($event)" placeholder="请选择" style="width:100px">
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
              </el-select>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" class="subheading">结论</td>
            <td style="width: 180px" colspan="3">{{bscUserInfoAgent.conclusion}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;" v-if="!isQualified">
            <!--                  <td style="width: 100px" class="subheading">结论</td>-->
            <!--                  <td style="width: 180px" >{{bscUserInfoAgent.conclusion}}</td>-->
            <td style="width: 100px" class="subheading">申请请示报告</td>
            <td style="width: 100px" colspan="3">
              <brupload
                  :refid="refid"
                  reftype="申请请示报告"
                  uploadflag
                  delflag
                  :before-upload="beforeUpload"
                  :showtime="false"
              >
              </brupload>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" class="subheading">网络运营经理确认</td>
            <td style="width: 180px">{{bscUserInfoAgent.quyuConfirm}}</td>
            <td style="width: 100px" class="subheading">省区经理确认</td>
            <td style="width: 100px" colspan="2">{{bscUserInfoAgent.daquConfirm}}</td>
          </tr>
        </table>
        <div class="h-pieceIn2">
          <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
            <h1>上传附件</h1>
          </div>
          <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
            上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!
          </div>
          <div class="h-formLine">
            <div class="h-pieceCon2 weekplandetail30">
              <el-form :model="bscUserInfoAgent"
                       ref="formLabelAlign1i"
                       :inline="true" :rules="rules" style="margin-left: 100px">
                <el-form-item label="公司缴纳社保人员数量" class="h-elformWrap-2" prop="upload1">
                  <brupload
                      :refid="refid"
                      reftype="公司缴纳社保人员数量"
                      :uploadflag="false"
                      :delflag="false"
                      :before-upload="beforeUpload"
                      :showtime="false"
                      :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
                <el-form-item label="上年度审计表" class="h-elformWrap-2" prop="upload2" style="margin-left: 180px">
                  <brupload
                      :refid="refid"
                      reftype="公司资产负债表"
                      :uploadflag="false"
                      :delflag="false"
                      :before-upload="beforeUpload"
                      :showtime="false"
                      :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
                <br>
                <el-form-item label="同行业品牌授权文件" class="h-elformWrap-2" prop="upload3">
                  <brupload
                      :refid="refid"
                      reftype="同行业品牌授权文件"
                      :uploadflag="false"
                      :delflag="false"
                      :before-upload="beforeUpload"
                      :showtime="false"
                      :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
                <el-form-item label="合同或业绩证明文件" class="h-elformWrap-2" prop="upload4"  style="margin-left: 180px">
                  <brupload
                      :refid="refid"
                      reftype="合同或业绩证明文件"
                      :uploadflag="false"
                      :delflag="false"
                      :before-upload="beforeUpload"
                      :showtime="false"
                      :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
                <el-form-item label="二类备案表" class="h-elformWrap-2" prop="upload4"  style="margin-left: 180px">
                  <brupload
                          :refid="refid"
                          reftype="二类备案表"
                          :uploadflag="false"
                          :delflag="false"
                          :before-upload="beforeUpload"
                          :showtime="false"
                          :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
                <el-form-item label="三类医疗器械许可证" class="h-elformWrap-2" prop="upload4"  style="margin-left: 180px">
                  <brupload
                          :refid="refid"
                          reftype="三类医疗器械许可证"
                          :uploadflag="false"
                          :delflag="false"
                          :before-upload="beforeUpload"
                          :showtime="false"
                          :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="center" style="margin-left: 400px;margin-top: 50px">
<!--          <el-button class="h-btn h-formBtn h-bgblueQ"-->
<!--                     @click="saveOrUpdate">保存-->
<!--          </el-button>-->
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     @click="choose1">导出Excel
          </el-button>
        </div>
        <div style="height: 50px"> </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ss from '../../api/SystemService'
import {genGraph} from '@/views/process/graph/Graph';

import mxgraph from '@/views/process/graph/index';
import agentCopyService from "../../api/loud/agent/agentCopyService";
import updownfile from "../../utils/updownfile";
import uploadFile from "../../api/process/account_complainUploadService";

export default {
  data() {
    return {
      showTaskList:false,
      usercode:"",
      bscUserInfoAgent:{
        usercode:"",
        customerName1:"",
        staffing:"",
        scale:"",
        qualification:"",
        brandPower:"",
        businessPower:"",
        conclusion:"",
        daquConfirm:"",
        quyuConfirm:"",

        areaname:"",
        creationDate:"",
        username:"",
        legal:"",
        name1:"",
        contactmobilephone:"",
        showscoretable:true,
        refid:"",
        againstAreaCount:"",
        againstUserCount:"",
      },
      refid: null,
      guancha:false,
      isQualified:false,
      inst:{
        daqu:"",
        quyu:"",
      },
      rules: {
        upload1:
            [
              {required: true, message: '请上传资料', trigger: 'blur'},
            ],
        upload2:
            [
              {required: true, message: '请上传资料', trigger: 'blur'},
            ],
        upload3:
            [
              {required: true, message: '请上传资料', trigger: 'blur'},
            ],
        upload4:
            [
              {required: true, message: '请上传资料', trigger: 'blur'},
            ],
      },
    };
  },

  computed: {
    UsercodeInfo:function(){
      return this.usercodeInfo;
    },
    Instid:function(){
      return this.instid;
    },
  },
  props: {
    usercodeInfo: {
      type: String,
    },
    instid: {
      type: String,
    },
  },

  mounted() {
    ss.SignService.queryAgent(this.UsercodeInfo).then(res => {
      console.log("11111",res)
      this.bscUserInfoAgent.usercode= res.obj.usercodeInfo;
      this.bscUserInfoAgent.customerName1= res.obj.customerName1Bas;
      this.bscUserInfoAgent.staffing= res.obj.staffingSco;
      this.bscUserInfoAgent.scale= res.obj.scaleSco;
      this.bscUserInfoAgent.qualification= res.obj.qualificationSco;
      this.bscUserInfoAgent.brandPower= res.obj.brandPowerSco;
      this.bscUserInfoAgent.businessPower= res.obj.businessPowerSco;
      this.bscUserInfoAgent.conclusion= res.obj.conclusionSco;
      this.bscUserInfoAgent.daquConfirm= res.obj.daquConfirmSco;
      this.bscUserInfoAgent.quyuConfirm= res.obj.quyuConfirmSco;
      this.bscUserInfoAgent.status= res.obj.statusSco;
      this.bscUserInfoAgent.instid= res.obj.instidSco;

      this.bscUserInfoAgent.areaname= res.obj.areanameInfo;
      this.bscUserInfoAgent.creationDate= res.obj.creationDateBas;
      this.bscUserInfoAgent.username= res.obj.usernameInfo;
      this.bscUserInfoAgent.legal= res.obj.legalBas;
      this.bscUserInfoAgent.name1= res.obj.name1Bas;
      this.bscUserInfoAgent.contactmobilephone= res.obj.contactmobilephoneBas;
      this.refid = res.obj.fileidInfo;
      this.bscUserInfoAgent.refid = res.obj.fileidInfo;
      this.bscUserInfoAgent.field = res.obj.fieldSco;

      if(res.obj.staffingSco == null || res.obj.staffingSco == ''|| res.obj.staffingSco == undefined){
        this.field = 2;
      }
      if(res.obj.fieldSco != null && res.obj.fieldSco != ''){
        this.field = res.obj.fieldSco;
      }
      this.getConclusion();
    })
    let query={
      agentCode:this.UsercodeInfo,
    }
    ss.annualTargetApi.selectUserByAgent(query).then(res =>{
      this.bscUserInfoAgent.againstAreaCount = res.obj;
    })
    ss.annualTargetApi.selectUserByUser(query).then(res =>{
      this.bscUserInfoAgent.againstUserCount = res.obj;
    })
  },
  methods: {
    ok(){
      this.usercode = this.UsercodeInfo
    },
    changeStaffing(res){
      this.bscUserInfoAgent.staffing = res;
      this.getConclusion();
    },
    changeScale(res){
      this.bscUserInfoAgent.scale = res;
      this.getConclusion();
    },
    changeQualification(res){
      this.bscUserInfoAgent.qualification = res;
      this.getConclusion();
    },
    changebrandPower(res){
      this.bscUserInfoAgent.brandPower = res;
      this.getConclusion();
    },
    changehBusinessPower(res){
      this.bscUserInfoAgent.businessPower = res;
      this.getConclusion();
    },

    getConclusion(){
      if(this.bscUserInfoAgent.staffing == 1 &&
          this.bscUserInfoAgent.scale == 1 &&
          this.bscUserInfoAgent.qualification == 1 &&
          this.bscUserInfoAgent.brandPower == 1 &&
          this.bscUserInfoAgent.businessPower == 1
      ){
        this.bscUserInfoAgent.conclusion = "合格";
        this.isQualified = true;
      }else {
        this.bscUserInfoAgent.conclusion = "不合格";
        this.isQualified = false;
      }
    },
    saveOrUpdate(){
      if(this.bscUserInfoAgent.staffing == null || this.bscUserInfoAgent.staffing == "" ||
          this.bscUserInfoAgent.scale == null || this.bscUserInfoAgent.scale == "" ||
          this.bscUserInfoAgent.qualification == null ||   this.bscUserInfoAgent.qualification == "" ||
          this.bscUserInfoAgent.brandPower == null || this.bscUserInfoAgent.brandPower == "" ||
          this.bscUserInfoAgent.businessPower == null ||this.bscUserInfoAgent.businessPower == ""){
        this.$message({
          message: "请完善评审项目!",
          type: 'error'
        });
        return;
      }
      let query = this.bscUserInfoAgent;
      ss.SignService.updateByIdScore(query).then(res =>{
        if(res.f){
          this.$message({
            message: "保存成功!",
            type: 'success'
          });
        }
        this.bscUserInfoAgent.showscoretable = false;
        this.$emit('choseObj', this.bscUserInfoAgent)
      })
      this.getConclusion();
    },
    choose1() {
      updownfile.down('/api/swyl/v1/agent/bscUserInfoAgent/getExcel',this.bscUserInfoAgent,"post");
    },
    beforeUpload(file){
      const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
      const isLt5M = file.size / 1024 / 1024 < 5;
      console.log(isFile,file.type)

      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传文件的大小不能超过 5M!');
        return false;
      }
    },
  }
}
</script>
<style>
.showflowDialogcls .el-dialog__body{
  padding-top: 0px!important;
}
::v-deep  .select{
  border: none;
  box-shadow: none;
}
</style>
<style scoped>
#graphContainer {
  overflow: hidden;
  width: 100%;
  min-height: 100px;
  padding-bottom: 20px;
  background: url('../../assets/images/flow/grid.gif');;
  border-radius: 4px;
}
.h-content {
  padding: 0rem 0.1rem 0 0.1rem;
}
.h-row .h-rowIn {
  padding: 0px !important;
}
.showTaskListClass {
  width:400px;
  border:1px solid #ccc;
  position: fixed;
  color:#333;
  font-size: 12px;
  z-index: 9999;
  background-color: rgba(255,255,255,0.8);
  border: 1px solid #c2c2c2;
  border-radius: 5px;
  padding: 12px;
}
.showTaskListClass  table {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
}
.showTaskListClass  table thead th{
  background-color: #57aefe;
  text-align: center;
  color:#fff;
}
.showTaskListClass table td, table th
{
  border: 1px solid #cad9ea;
  color: #666;
  height: 30px;
}
.showTaskListClass table tr:nth-child(odd)
{
  background: #fff;
}
.showTaskListClass table tr:nth-child(even)
{
  background: #F5FAFA;
}
.outTimeline {
  background-color: #fcfcfc;
  border-radius: 10px;
}
.title{
  font-size: 20px;
  font-weight:bold;
}
.subheading{
  font-weight:bold;
}

</style>

